import {onFind} from "@elements/init-modules-in-scope";
import {addClass, removeClass, on} from "@elements/dom-utils";
import {isScrollLock} from "@elements/scroll-lock";

export function init () {
    onFind('.js-scroll-indicator', ((scrollIndicator) => {
        let scrollPos = window.pageYOffset;
        const addClassOnScroll = () => addClass('not-visible', scrollIndicator);
        const removeClassOnScroll = () => removeClass('not-visible', scrollIndicator);


        window.addEventListener('scroll', function() {
            scrollPos = window.pageYOffset;

            if (scrollPos === 0 && !isScrollLock()) {
                removeClassOnScroll();
            } else {
                if (scrollPos >= 50) {
                    addClassOnScroll();
                } else {
                    if (!isScrollLock()) {
                        removeClassOnScroll();
                    }
                }
            }
        }, false);
    }));
}